import http from '../config/http';
import routes from '../config/api_routes';

export const save = () => {
    return http().post( routes.paymentCard.all);
}
export const block = (id,data) => {
    var route = (routes.paymentCard.byId||'').replace(':id', id)
    return http().put(route, data)
}
